// These types must be kept in sync with the OrgFunction enum in the backend
export const SPORT_ADMIN_NATIONAL = "SPORT_ADMIN_NATIONAL";
export const SPORT_ADMIN_STATE = "SPORT_ADMIN_STATE";
export const SPORT_ADMIN_REGIONAL = "SPORT_ADMIN_REGIONAL";
export const SOFTWARE_VENDOR = "SOFTWARE_VENDOR";